import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { GetSoundList, GlobalUrl, SoundUpdate, SoundAdd, SoundDelete } from '../db/db'
import { Form, Col, Row, Button, Modal, ProgressBar } from "react-bootstrap";
import { FaNewspaper, FaTrashAlt, FaWpforms } from 'react-icons/fa';
import { useAlert } from "react-alert";
const Sounds = (props) => {
    const QIssueIDData = (window.location.search.split("?MID=")[1] != undefined) ? window.location.search.split("?MID=")[1] : window.location.pathname.split('/')[1]
    const [QIssueID, setQIssueID] = useState(QIssueIDData)
    const [videList, setVideoList] = useState([])
    const [visibEdit, setVisEdit] = useState("none")
    const [selectVideo, setDelectVide] = useState()
    const [selectOwner, setOwner] = useState()

    const LoadVideoList = async () => {
        const videList = await GetSoundList(props.MagazineID).then((res) => {
            console.log("ses", res.sonuc)
            setVideoList(res.sonuc)
        })
    }
    useEffect(async () => {
        LoadVideoList()
    }, [])
    const myAlert = useAlert();
    return (
        <>
            <hr style={{ color: 'GrayText', size: "3" }} />
            <div style={{ textAlign: 'center', fontWeight: "bold" }}>Fon Sesi Listesi</div>
            <hr style={{ color: 'GrayText', size: "3" }} />
            <Form.Control accept="audio/*" type="file" placeholder="Güncelle" style={{ margin: 7 }}
                onChange={
                    (e) => {
                        setDelectVide(e.target.files[0])
                    }}
            />
            <Form.Control id="SesSahibi" type="text" placeholder="Ses Sahibi" style={{ margin: 7 }} />
            <Button className="btn-light" size="sm" active style={{ margin: 7 }} onClick={async () => {
                const UpdateResult = await SoundAdd(selectVideo, 0, QIssueID, 0, document.getElementById("SesSahibi").value).then((result) => {

                    LoadVideoList()
                    myAlert.success("Sesi Dosyası İşlendi")
                    return result
                })
            }} > <FaNewspaper /> Yeni Ekle
            </Button>
            {
                //console.log("videos",videList)
                videList.map((data, index) => {
                    const imgData =  data.soundPath;
                    const ownerData=data.owner
                    return (
                        <div>
                            <div id={index} style={{ height: 20 }} >{imgData}</div><br />
                            <Form.Control accept="audio/*" type="file" placeholder="Güncelle" style={{ margin: 7 }}
                                onChange={
                                    (e) => {
                                        setDelectVide(e.target.files[0])
                                    }}
                            />
                            <Form.Control id={"SesSahibi" + index} type="text" placeholder={ownerData}   style={{ margin: 7 }} />
                            <Button className="btn-light" size="sm" active style={{ margin: 7 }} onClick={async () => {
                                const UpdateResult = await SoundUpdate(selectVideo, 0, QIssueID, data.id, document.getElementById("SesSahibi" + index).value).then((result) => {
                                    myAlert.success("Ses Bilgileri İşlendi!")
                                    LoadVideoList()
                                    return result
                                })

                                console.log("other const", UpdateResult)
                            }} > <FaWpforms /> Güncelle
                            </Button>
                            <Button className="btn-light" size="sm" active style={{ margin: 7 }} onClick={async () => {
                                const UpdateResult = await SoundAdd(selectVideo, 0, QIssueID, data.id).then((result) => {

                                    LoadVideoList()
                                    myAlert.success("video Dosyası İşlendi")
                                    return result
                                })
                            }} > <FaNewspaper /> Yeni Ekle
                            </Button>
                            <Button className="btn-light" size="sm" active style={{ margin: 7 }} onClick={async () => {
                                const UpdateResult = await SoundDelete(data.id).then((result) => {

                                    LoadVideoList()
                                    myAlert.success("video silme tamamlandı")
                                    return result
                                })

                            }} > <FaTrashAlt /> Sil
                            </Button>
                        </div>)
                })
            }
        </>
    )
}

export default Sounds
